import script from "./RollingCylinder.vue?vue&type=script&setup=true&lang=js"
export * from "./RollingCylinder.vue?vue&type=script&setup=true&lang=js"

import "./RollingCylinder.vue?vue&type=style&index=0&id=aa5fe68c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa5fe68c"]])

export default __exports__